<script>

import init from '@/functions/game'

export default {
  name: 'game',
  mounted () {
    init()
  }
}
</script>
<template>
    <div class="game">
        <h1>Elemental</h1>

        <div class="exitModal">
            <div class="modal">
                Bonjour
            </div>
        </div>
        <div class="grid">
            <div id="empty-1" class="empty"></div>
            <div id="empty-2" class="empty"></div>
            <div id="empty-3" class="empty"></div>
            <div id="empty-4" class="empty"></div>
            <div id="empty-5" class="empty"></div>
            <div id="empty-6" class="empty"></div>
            <div id="empty-7" class="empty"></div>
            <div id="empty-8" class="empty"></div>
            <div id="empty-9" class="empty"></div>
            <div id="empty-10" class="empty"></div>
            <div id="empty-11" class="empty"></div>
            <div id="empty-12" class="empty"></div>
            <div id="empty-13" class="empty"></div>
            <div id="empty-14" class="empty"></div>
            <div id="empty-15" class="empty"></div>
            <div id="empty-16" class="empty"></div>
        </div>

        <div class="resultGame">Victoire, cliquer pour recommencer</div>

        <div class="elements">
            <div id="eau-1" class="element water" draggable="true"></div>
            <div id="eau-2" class="element water" draggable="true"></div>
            <div id="eau-3" class="element water" draggable="true"></div>
            <div id="eau-4" class="element water" draggable="true"></div>
            <div id="air-1" class="element air" draggable="true"></div>
            <div id="air-2" class="element air" draggable="true"></div>
            <div id="air-3" class="element air" draggable="true"></div>
            <div id="air-4" class="element air" draggable="true"></div>
            <div id="terre-1" class="element earth" draggable="true"></div>
            <div id="terre-2" class="element earth" draggable="true"></div>
            <div id="terre-3" class="element earth" draggable="true"></div>
            <div id="terre-4" class="element earth" draggable="true"></div>
            <div id="feu-1" class="element fire" draggable="true"></div>
            <div id="feu-2" class="element fire" draggable="true"></div>
            <div id="feu-3" class="element fire" draggable="true"></div>
            <div id="feu-4" class="element fire" draggable="true"></div>
        </div>
    </div>
</template>
<style>
.game {
    background-image: linear-gradient( 135deg, #FEB692 10%, #EA5455 100%);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
}

.exitModal {
    position: fixed;
    z-index: 100;
    background-color: rgba(0, 0, 0, .7);
    width: 100%;
    height: 100vh;
    display: none;
    align-items: center;
    justify-content: center;
}

.modal {
    width: 95%;
    height: 100px;
    display: flex;
    align-items: center;
    border-radius: 5px;
    justify-content: center;
    font-family: sans-serif;
    font-size: 30px;
    color: #263238;
}

.grid {
    display: grid;
    grid-template-columns: repeat(4, 80px);
    grid-template-rows: repeat(4, 80px);
    border: 1px solid black;
}

.empty {
    border: 1px solid black;
    background-color: white;
    padding: 10px;
}

.hovered {
    background-color: blue;
}

.invisible {
    display: none;
}

.resultGame {
    text-shadow: 1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff;
    display: none;
    height: 80px;
    margin-top: 20px;
    font-family: sans-serif;
    font-size: 30px;
    font-weight: bolder;
    text-align: center;
}

.elements {
    margin-top: 20px;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(4, 80px);
    grid-template-rows: 80px;
}

.element {
    width: 100%;
    height: 100%;
    cursor: pointer;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    touch-action: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
}

.water {
    background-color: midnightblue;
    grid-column: 1 / span 1;
    grid-row: 1 / span 1;
}
.air {
    background-color: skyblue;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
}
.earth {
    background-color: peru;
    grid-column: 3 / span 1;
    grid-row: 1 / span 1;
}
.fire {
    background-color: orangered;
    grid-column: 4 / span 1;
    grid-row: 1 / span 1;
}

@media (min-width: 768px) {
    .grid {
        grid-template-columns: repeat(4, 100px);
        grid-template-rows: repeat(4, 100px);

    }
    .elements {
        grid-template-columns: repeat(4, 100px);
        grid-template-rows: 100px;
    }
}
</style>
